import { makeActionCreator } from '../../../utilities'
import { SubmitChartConstants } from './submitChart.constants'

export const preSubmitChart = makeActionCreator(SubmitChartConstants.SET_PRE_SUBMIT_CHART)
export const doSubmitChart = makeActionCreator(SubmitChartConstants.SUBMIT_CHART)
export const postSubmitChart = makeActionCreator(SubmitChartConstants.SET_POST_SUBMIT_CHART, 'submitChart')
export const resetSubmitChartState = makeActionCreator(SubmitChartConstants.RESET_STATE)
export const getSubmitChartState = makeActionCreator(SubmitChartConstants.GET_SUBMIT_CHART_STATE)
export const setSubmitChartState = makeActionCreator(SubmitChartConstants.SET_SUBMIT_CHART_STATE, 'submitChart')
export const SetValidationMessage = makeActionCreator(SubmitChartConstants.SET_VALIDATION_MESSAGE, 'validationMessage')
export const updateSubmitChartValidationState = makeActionCreator(
  SubmitChartConstants.UPDATE_SUBMIT_CHART_VALIDATION_STATE
)
export const getSubmitChartValidationArray = makeActionCreator(SubmitChartConstants.GET_SUBMIT_CHART_VALIDATION_ARRAY)
